export default [
  {
    path: "/ticket/list",
    name: "Ticket list",
    component: () => import("@/views/Tickets/ListTickets"),
    meta: {
      pageTitle: "Tickets List",
      breadcrumb: [
          {
            text: 'Tickets List',
            active: true,
          },
        ],
    },
  },
  {
    path: "/ticket/:id/show",
    name: "Ticket single",

    component: () => import("@/views/Tickets/SingleTicket"),
    meta: {
    action: "Ticket list",
      pageTitle: "Ticket",
      breadcrumb: [
          {
            text: 'Ticket Show',
            active: true,
          },

        ],
    },
  },

  {
    path: "/ticket/create",
    name: "Ticket create",
    component: () => import("@/views/Tickets/UpsertTicket"),
    meta: {
      pageTitle: "Ticket Create",
      breadcrumb: [
        {
          text: 'Ticket Create',
          active: true,
        },
      ],
    },
  },
  {
    path: "/ticket/create/:owner_id/:owner_type",
    name: "Ticket create",
    component: () => import("@/views/Tickets/UpsertTicket"),
    meta: {
      pageTitle: "Ticket Create",
      breadcrumb: [
        {
          text: 'Ticket Create',
          active: true,
        },
      ],
    },
  },

  {
    path: "/ticket/:id/update",
    name: "Ticket update",
    component: () => import("@/views/Tickets/UpsertTicket"),
    meta: {
      pageTitle: "Ticket Update",
      breadcrumb: [
        {
          text: 'Ticket Update',
          active: true,
        },
      ],
    },
  },

];
